import { Landmark, Banknote } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { CuentaBancaria, Moneda } from '@/contabilidad/types';
import { formatAmount } from '@/contabilidad/utils/formatters';
import { CARD_BASE } from '@/contabilidad/constants/ui';

interface CuentasCardsProps {
  cajas: CuentaBancaria[];
}

function formatSaldo(saldo: number, moneda: Moneda): string {
  return `${moneda} $ ${formatAmount(saldo, moneda)}`;
}

export function CuentasCards({ cajas }: CuentasCardsProps) {
  return (
    <div className="col-span-12 flex flex-wrap gap-5">
      {cajas.map((caja) => {
        const Icon = caja.tipo === 'banco' ? Landmark : Banknote;
        return (
          <div
            key={caja.id}
            className={cn(CARD_BASE, 'grow shrink min-w-0 basis-[260px] p-4 flex flex-col gap-1')}
          >
            <div className="flex items-center justify-between mb-1">
              <div className={cn(
                'size-8 rounded-lg flex items-center justify-center bg-slate-100',
              )}>
                <Icon className={cn('size-4 text-slate-500')} />
              </div>
              <span className={cn(
                'text-xs font-bold px-2 py-0.5 rounded-full bg-slate-100 text-slate-600',
              )}>
                {caja.moneda}
              </span>
            </div>
            <span className="text-xs text-muted-foreground">{caja.nombre}</span>
            <span className="break-words text-lg font-bold text-gray-900 tabular-nums">
              {formatSaldo(caja.saldo, caja.moneda)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
